module.exports = __webpack_public_path__ + "img/next-step-lines-bg.4eacc1fc.png";